export default __webpack_public_path__ + "static/media/plus.9adcf732.svg";